import { useForm } from "react-hook-form";
import RadioGroup from "../../Components/CommonCommponents/RadioGroup";
import Input from "../../Components/CommonCommponents/Input";
import { useEffect } from "react";
import { Button } from "antd";
import Select from "../../Components/CommonCommponents/select/Select";
import AuthService from "../../Service.js/authService";
import { useState } from "react";
import DatePicker from "../../Components/CommonCommponents/DatePicker";
import CandodateService from "../../Service.js/CandidateService";
import toast from "react-hot-toast";
import { dateConverter } from "../../Components/Utilities/util";
import dayjs from "dayjs";
import TextEdit from "../../Components/CommonCommponents/TextEditor";

const preferredWorkType=[
  { value: "FULL_TIME", label: "Full Time" },
  { value: "PART_TIME", label: "Part Time" },
  { value: "CONTRACT", label: "Contract" },
  { value: "FREELANCE", label: "Freelance" },
  { value: "TEMPORARY", label: "Temporary" },
  { value: "INTERNSHIP", label: "Internship" },
  { value: "CONSULTANT", label: "Consultant" },
  { value: "ON_CALL", label: "On-Call" },
  { value: "HOURLY", label: "Hourly" },
  { value: "COMMISSION", label: "Commission-Based" },
  { value: "APPRENTICESHIP", label: "Apprenticeship" },
  { value: "REMOTE", label: "Remote" },
  { value: "GIG_WORK", label: "Gig Work" },
  { value: "VOLUNTEER", label: "Volunteer" },
  { value: "PROBATIONARY", label: "Probationary" },
  { value: "HYBRID", label: "Hybrid" },
  { value: "SEASONAL", label: "Seasonal" },
  { value: "PER_DIEM", label: "Per Diem" },
  { value: "SELF_EMPLOYED", label: "Self-Employed" },
  { value: "FIXED_TERM", label: "Fixed-Term" },
  { value: "CASUAL", label: "Casual" },
  { value: "SHIFT_WORK", label: "Shift Work" },
  { value: "JOB_SHARE", label: "Job Share" },
  { value: "RETAINER", label: "Retainer" },
  { value: "PORTFOLIO", label: "Portfolio Career" },
  { value: "TEMP_TO_PERM", label: "Temp-to-Perm" },
  { value: "SUBCONTRACT", label: "Subcontract" },
  { value: "CO_OP", label: "Co-Op" },
  { value: "TELECOMMUTE", label: "Telecommute" }
]



const AddExperience = (props) => {
  console.log("props", props);
  const {
    register,
    unregister,
    control,
    setValue,
    setError,
    watch,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm();
  const [experience, setExperience] = useState();
  const [description, setDescrption] = useState();

  const ANSWER_OPTIONS = [
    { label: "Yes", value: "true" },
    { label: "No", value: "false" },
  ];
  const selectedItem = watch("is_current_company");
  console.log("tester", selectedItem);
  useEffect(() => {
    console.log("enteredddddddd", selectedItem);
    if (selectedItem === "true") {
      console.log("enteredddddddd");
      unregister("worked_till");
    } else {
      register("worked_till");
    }
  }, [selectedItem]);

  const experienceinfo = async () => {
    await CandodateService.getExperienceDetails()
      .then((response) => {
        console.log("response", response.data.data);
      })
      .catch((error) => {});
  };
  const getExperieceinfo = async () => {
    await CandodateService.getExperienceById(props.experienceId)
      .then(
        (oResponse) => {
          console.log("oResponseccc", oResponse.data.data);
          setExperience(oResponse.data.data);
          getData(oResponse.data.data);
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
      });
  };

  const getData = (data) => {
    setValue("is_current_company", data?.is_current_company.toString());
    setValue("experience", data?.experience);
    setValue("designation", data?.designation);
    if (data?.worked_from) {
      setValue("worked_from", dayjs(data?.worked_from));
    }
    if (data?.worked_till) {
      setValue("worked_till", dayjs(data?.worked_till));
    }
    setValue("company", data?.company);
    setValue("job_type", data?.job_type);
    setValue(
      "preferred_working_conditions",
      data?.preferred_working_conditions
    );
  };
  useEffect(() => {
    getExperieceinfo();
    getData();
  }, []);

  const sendData = async (data) => {
    console.log("tetslog", data);

    // const date = dateConverter(data.worked_from)
    // const worked_from = date.convertedValue
    // const date2 = dateConverter(data.till)
    // const worked_till = date2.convertedValue
    // data["worked_from"] = worked_from;
    // data["worked_till"] = worked_till;
    data["worked_from"] = data.worked_from
      ? dayjs(data.worked_from).format("YYYY-MM-DD")
      : null;
    data["worked_till"] = data.worked_till
      ? dayjs(data.worked_till).format("YYYY-MM-DD")
      : null;
    data["experience"] = description;

    await CandodateService.addExperience(data)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Added!");
          props.close();
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };
  const onChange = (e) => {
    setDescrption(e);
  };
  console.log("job", description);
  const updateData = async () => {
    const data = getValues();
    console.log(data, "data.till");
    // const date = dateConverter(data.worked_from)
    // const worked_from = date.convertedValue
    // const date2 = dateConverter(data.till)
    // const worked_till = date2.convertedValue
    data["worked_from"] = data.worked_from
      ? dayjs(data.worked_from).format("YYYY-MM-DD")
      : null;
    data["worked_till"] = data.worked_till
      ? dayjs(data.worked_till).format("YYYY-MM-DD")
      : null;
    data["experience"] = description;

    await CandodateService.updateExperience(data, props.experienceId)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Added!");

          props.close();
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };
  const onSubmit = async (data) => {
    if (props.experienceId) {
      updateData(data);
    } else {
      sendData(data);
    }
  };

  console.log(selectedItem === "true", "selectedItem");

  return (
    <div className="w-full pb-6 p-4 flex">
      <form className=" w-full" onSubmit={handleSubmit(onSubmit)}>
        <div class="px-2">
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <RadioGroup
                name="is_current_company"
                //defaultValue={props.experienceId ? experience?.current_company:""}
                label="Is this your current employment?"
                control={control}
                rules={{
                  required: "At least 1 option must be chosen",
                }}
                options={ANSWER_OPTIONS}
              />
            </div>
          </div>
          {/* <div class="flex -mx-2 md:flex-row flex-col">
                        <div class="w-full px-4">
                            <Input
                                name="preferred_working_conditions"
                                label="Employment Type"
                                control={control}
                                rules={{
                                    required: 'This field is required'
                                }}
                                className="h-12 "
                            />
                        </div>
                    </div> */}
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <Input
                name="designation"
                label="Designation"
                control={control}
                rules={{
                  required: "This field is required",
                }}
                className="h-12 "
              />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <Input
                name="company"
                label="Company Name"
                placeholder=""
                control={control}
                rules={{
                  required: "This field is required",
                }}
                className="h-12 "
              />
            </div>
          </div>

          <div class="flex -mx-2 md:flex-row flex-col">

          <div class="w-full px-4">
              <Select
                name="job_type"
                placeholder="Select"
                label="Employment Type"
                control={control}
                rules={{
                  required: "This field is required",
                }}
                options={preferredWorkType.map((oOption) => {
                  return {
                    value: oOption.value,
                    label: oOption.label,
                  };
                })}
                onChange={(e, onChange) => onChange(e.value)}
                className="multiSelect "
              />
            </div>
          </div>

          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
            <DatePicker
              label="Joining Date"
              name="worked_from"
              noTextInput
              rules={{
                required: "Please Choose a Date",
              }}
              control={control}
              placeholder="Select"
              className="h-12"
              disableFutureDays={true}
              maxDate={dayjs().subtract(1, "day")} 
            />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <DatePicker
                label="Worked Till"
                name="worked_till"
                disabled={selectedItem === "true"}
                noTextInput
                showToday
                rules={
                  selectedItem === "true"
                    ? {}
                    : {
                        required: "Please Choose a Date",
                      }
                }
                control={control}
                placeholder="Select"
                // disablePreviousDays
                className="h-12"
                disableFutureDays={true}
                minDate={watch("worked_from") ? dayjs(watch("worked_from")).add(1, 'day') : undefined}
              />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <label className=" text-medium mb-2 text-start ">
                Job Responsibilty
              </label>
              <div className="mt-4">
                <TextEdit
                  onChange={onChange}
                  id="description"
                  initialValue={experience?.experience}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap justify-end mt-6 px-4">
          <Button
            htmlType="submit"
            type="submit"
            className="bg-[#000000] text-white text-base rounded-3xl"
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddExperience;
